import { call, put } from 'redux-saga/effects';
import { BuyersAsyncActions } from 'store/actions/buyers';
import { apiCall } from 'utils/apiCall';

function* fetch(action) {
  const {
    FetchBuyer: {
      Actions: { SUCCESS, FAILURE },
    },
  } = BuyersAsyncActions;

  const {
    payload: { id },
  } = action;

  try {
    const response = yield call(apiCall, `/offers/buyers/${id}`, 'get');
    yield put(SUCCESS(response.data));
  } catch (error) {
    yield put(FAILURE(error));
  }
}

export default fetch;
